import { apiClient, getAuthHeader } from "./apiConfig";

export const fetchActiveFaqs = async () => {
  const res = await apiClient.get(`/faqs/active`);
  return res.data?.data || [];
};

export const fetchFaqs = async () => {
  const res = await apiClient.get(`/faqs/get_all`, getAuthHeader());
  return res.data?.data || [];
};

export const createFaq = async (payload) => {
  return apiClient.post(`/faqs/create`, payload, {
    ...getAuthHeader(),
    headers: { "Content-Type": "application/json", ...getAuthHeader().headers },
  });
};

export const updateFaq = async (id, payload) => {
  return apiClient.post(`/faqs/update/${id}`, payload, {
    ...getAuthHeader(),
    headers: { "Content-Type": "application/json", ...getAuthHeader().headers },
  });
};

export const deleteFaq = async (id) => {
  return apiClient.delete(`/faqs/delete/${id}`, getAuthHeader());
};
